import { SvgComponentProps } from "@/src/types/SVGPropType"
import * as React from "react"
const ArrowRight3SVG:React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ? props.width : 4}
    height={props.width ? props.width : 7}
    fill="none"
    viewBox="0 0 4 7"
    {...props}
  >
    <path
      fill="#A1A4AA"
      fillRule="evenodd"
      d="m1.061.267.398.398 2.117 2.118a.75.75 0 0 1 0 1.06L1.46 5.961l-.398.397-.795-.795.397-.398 1.853-1.852L.663 1.46l-.397-.398.795-.796Z"
      clipRule="evenodd"
    />
  </svg>
)
export default ArrowRight3SVG
